<ng-template *ngIf="template" [ngTemplateOutlet]="template"
             [ngTemplateOutletContext]="{type: type, formControlName: fcName, formGroup: group, label: label, toolTip: toolTip, required: required,
             additionalParams: additionalParams}">
</ng-template>

<!--Einfaches Eingabefeld als Fallback-->
<div *ngIf="!template" [formGroup]="group">

        <common-form-field *ngIf="!multi" [label]="label" [class]="required ? 'required-class' : ''">
            <common-form-input  [formControlName]="fcName" [dataToolTip]="toolTip"></common-form-input>
        </common-form-field>

        <common-control-value-mapper *ngIf="multi"  [formControlName]="fcName"
            [toModel]="splitValuesToArray" [fromModel]="joinValuesFromArray" >
            <common-form-field  label="{{label}} (kommasepariert)" [class]="required ? 'required-class' : ''">
                <common-form-input #cvDelegate [dataToolTip]="toolTip"></common-form-input>
            </common-form-field>
        </common-control-value-mapper>

</div>
